<template>
    <div>
        <b-modal id="modal-Partner" size="lg" class="modal-form" :title="modal_title" @hidden="CLEAR_FORM()" centered hide-footer>
            <ValidationObserver ref="form">
                <validation-provider v-if="!formdata.photo" rules="mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                    <div class="form-group" v-if="!formdata.photo">
                        <div class="mb-1">
                            <label>Partner Logo</label>
                        </div>
                        <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputImage.click()">
                            <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                        </div>
                        <input ref="inputImage" 
                                type="file"
                                class="custom-file-input d-none"
                                id="Thumbnail"
                                v-on:change="onImageUpload"
                                accept="image/jpeg,image/png,image/jpg" 
                                @input="validate" >
    
                        <div class="invalid-input mt-3">{{ errors[0] }}</div>
                    </div>
                </validation-provider>
                
                <div class="form-group" v-if="formdata.photo">   
                    <div class="mb-1">
                        <label>Partner Logo</label>
                    </div> 
                    <button v-on:click.prevent="removeImageUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Partner</button> 
                    <div class="input-group img-sh">
                        <img :src="formdata.photo" class="img-responsive img-prf">
                    </div>
                    <div class="invalid-input mt-3">{{ errors[0] }}</div>
                </div>

                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Partner Name</label>
                        <input v-model="formdata.name" type="text" class="form-control" name="name">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <b-row>
                    <b-col md="6">
                        <validation-provider rules="email" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Email</label>
                                <input v-model="formdata.email" type="text" class="form-control" name="name">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </b-col>

                    <b-col md="6">
                        <div class="form-group">
                            <label>Phone</label>
                            <input v-model="formdata.phone" type="text" class="form-control" name="name">
                        </div>
                    </b-col>
                    
                </b-row>
                <div class="form-group">
                    <label>Address</label>
                    <input v-model="formdata.address" type="text" class="form-control" name="name">
                </div>

                <validation-provider rules="multi_url" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Social Media</label>
                        <textarea v-model="formdata.sosmed_link" class="form-control"></textarea>
                        <small>Separate urls with commas(,) if you want to load more than one link</small>
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <div class="button-modal text-right">
                    <button v-on:click="validationForm(formdata.id)" type="button" class="btn btn-new" v-bind:class="loading ? 'btn-progress' : ''">
                        Save Data
                    </button>
                </div>
            </ValidationObserver>
        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver} from "vee-validate";

    export default{
        data(){
            return{
                loading:false,
                modal_title : 'Add Partner',
                photo_file:'',
            }
        },
        props: ['del_partner'],
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        computed: {
            ...mapState('PartnerControl', {
                formdata: state => state.formdata,
                errors: state => state.errors
            }),
        },
        watch:{
            'formdata':function(val){
                if(val.id){
                    this.modal_title = 'Edit Partner'
                }else if(!val.id){
                    this.modal_title = "Add Partner"
                }
            },
        },
        methods: {
            ...mapActions('PartnerControl', ['createPartner','updatePartner']),
            ...mapMutations('PartnerControl', ['CLEAR_FORM']),
            
            onImageUpload: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.formdata.photo = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this.photo_file = input.files[0]
            },
            removeImageUpload:function(){
                this.photo_file = ''
                this.formdata.photo = ''
            },
            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var formData = new FormData();
                        formData.append('name', this.formdata.name);
                        formData.append('email', this.formdata.email ? this.formdata.email : '');
                        formData.append('phone', this.formdata.phone ? this.formdata.phone : '');
                        formData.append('address', this.formdata.address ? this.formdata.address : '');
                        formData.append('sosmed_link', this.formdata.sosmed_link ? this.formdata.sosmed_link : '');
                        formData.append('photo', this.formdata.photo ? this.formdata.photo : '');
                        formData.append('photo_file', this.photo_file);
                        
                        if(id){

                            formData.append("_method", "put");
                            this.updatePartner(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Partner')
                                this.$emit('getPartner');
                                this.CLEAR_FORM()
                                this.$toast.success('Successfully Update Partner')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })

                        }else{

                            this.createPartner(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Partner')
                                this.$emit('getPartner');
                                this.CLEAR_FORM()
                                this.$toast.success('Successfully Added Partner')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })
                        }
                    }
                });
            },
        }
    }
</script>
